import { render, staticRenderFns } from "./themify.vue?vue&type=template&id=142af91c&"
import script from "./themify.vue?vue&type=script&lang=js&"
export * from "./themify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports